import AppRoute from "models/AppRoute"
import { AssetImportItemStatus } from "models/AssetImportItem"

const AssetImportRoute = new AppRoute<{}, { filter: AssetImportItemStatus }>({
    route: "/import-assets",
    navbar: true,
    authRequired: true,
})

export default AssetImportRoute
